import React from 'react';
import { DivSuccess } from '../contactForm/ContactElements';

export default function SuccessPay(){
    return(
        <DivSuccess>
        </DivSuccess>
    );
}